<template>
  <div class="centrum-page fixed-nav">
    <MainHeader
      :dark="false"
      :fixedMenu="true"
      :loginButton="false"
      :tiles="false"
      @logoClick="logoClick"
    >
      <svg>
        <use v-if="selectedTranslation === 'en'" xlink:href="#logoCentrumSvgEng"></use>
        <use v-else xlink:href="#logoCentrumSvg"></use>
      </svg>
    </MainHeader>
    <div class="sections">
      <section class="section-main">

        <div class="back-btn-bar">
          <button type="button"
                  class="back-btn"
                  @click.stop="backBtnClick()">
            <svg height="14" width="24"><use xlink:href="#arrowBackSvg"></use></svg>
          </button>
        </div>

        <div class="container container-small">
          <div class="centrum-page-header" v-if="pageData.title">
            <h1 class="text-xl underline accent">
              {{ pageData.title }}
            </h1>
            <p class="text-m paragraph" v-if="pageData.text">
              {{ pageData.text }}
            </p>
          </div>

          <div class="centrum-page-list" v-if="articles.length">
            <ul>
              <template v-for="(article, index) in articles">
                <li v-if="article"
                    :key="'article' + index"
                    :class="{
                      'hidden': article.icon && isPhone,
                      'text-center': article.icon
                    }">
                  <a href="#" v-if="!article.icon" @click.prevent.stop="openPopup(article)">
                    <h2 class="underline">
                      {{ article.name }}
                    </h2>
                    <span class="btn-simple">
                      {{ buttonData.seeMore }}
                    </span>
                  </a>
                  <template v-else>
                    <AnimatedShape
                      v-if="!isPhone"
                      :id="article.icon"
                      color="gray"
                      :loop="false"
                      :visible="false" />
                  </template>
                  <span class="centrum-page-list-cross"></span>
                </li>
              </template>
            </ul>
            <span class="centrum-page-list-cross centrum-page-list-last-cross"></span>
          </div>

        </div>

      </section>
      <MainFooter
        key="footer"
        :content="footerData"
      />
    </div>
    <section class="modal" v-if="openModal">
      <div class="modal-content">
        <PopupContentLoader
          v-if="articleContent"
          :popupContent="articleContent"/>
        <div v-else class="container container-small">
          <AccentHeader
            :header="errorData.title"
            :underline="true"
            :uppercase="false"
          />
          <div class="error-404">
            <p class="text-m paragraph">
              {{ errorData.networkError }}<br />
              {{ errorData.tryAgain }}
            </p>
          </div>
        </div>

      </div>
      <button type="button" class="modal-close btn-close" :title="buttonData.close" @click="toggleModal()">
        <svg>
          <use xlink:href="#closeSvg"></use>
        </svg>
      </button>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MainHeader from '@/components/MainHeader.vue'
import MainFooter from '@/components/MainFooter.vue'
import AccentHeader from '@/components/AccentHeader.vue'
import AnimatedShape from '@/components/AnimatedShape.vue'
import PopupContentLoader from '@/components/PopupContentLoader.vue'

export default {
  name: 'CentrumPage',
  components: {
    MainHeader,
    MainFooter,
    AccentHeader,
    AnimatedShape,
    PopupContentLoader
  },
  data: () => {
    return {
      articles: [
        {
          name: '',
          description: '',
          params: [],
          link: '',
          icon: 'infinity'
        }
      ],
      grid: {
        sm: 2,
        md: 3,
        lg: 4
      },
      openModal: false,
      pageData: {
        title: '',
        text: ''
      },
      articleContent: null
    }
  },
  methods: {
    ...mapActions([
      'resetActiveFilters',
      'togglePageScrolls'
    ]),
    logoClick () {
      this.$router.push({ 'name': 'centrum-edukacji' })
    },
    backBtnClick () {
      this.$router.go(-1)
    },
    toggleModal () {
      this.togglePageScrolls(this.openModal)
      this.openModal = !this.openModal

      if (!this.openModal) {
        this.articleContent = null
      }
    },
    openPopup (article) {
      this.articleContent = article
      this.toggleModal()
    },
    getPageData () {
      const section = (this.centrumData.sections && this.centrumData.sections[this.$route.params.page] ? this.centrumData.sections[this.$route.params.page] : null)
      if (section) {
        this.pageData = {
          title: section.name,
          text: section.description
        }

        if (section.courses) {
          this.articles = this.fillEmptySpaces(section.courses)
        }
      }
    },
    getArticlesList () {
      const section = (this.centrumData.sections && this.centrumData.sections[this.$route.params.page] ? this.centrumData.sections[this.$route.params.page] : null)
      if (section && section.courses) {
        this.articles = this.fillEmptySpaces(section.courses)
      }
    },
    fillEmptySpaces (arr) {
      if (!this.wWidth || this.wWidth === 'xs') {
        return arr
      } else {
        const cols = (this.grid[this.wWidth] ? this.grid[this.wWidth] : 4)
        const rows = Math.ceil(arr.length / cols)
        const maxItems = ((rows * cols) + cols)
        const availableIcons = ['infinity', 'circle', 'square', 'orbit']
        let freeSpace = (arr.length >= cols ? (Math.ceil(maxItems % arr.length) ? Math.ceil(maxItems % arr.length) : (arr.length - cols)) : (cols - arr.length))
        let randomIndex = []
        let retArray = []
        let tempIndex = 0

        if (freeSpace === 0) {
          retArray = arr
        } else {
          for (let i = 0; i < freeSpace; i++) {
            let randomNumber = (((cols - 1) * i) + 2)
            randomIndex.push(randomNumber <= ((rows * cols) - 1) ? randomNumber : ((arr.length - 1) <= freeSpace ? (i + arr.length) : (arr.length - 1)))
          }
          // FILL IN EMPTY SPACES WITH ICONS;
          for (let i = 0; i <= maxItems; i++) {
            let toPush = {}

            if (freeSpace > 0 && randomIndex.indexOf(i) !== -1) {
              const iconIndex = Math.ceil(freeSpace % availableIcons.length)

              toPush = {
                icon: (availableIcons[iconIndex] ? availableIcons[iconIndex] : 'infinity')
              }
              tempIndex--
              freeSpace--
            } else {
              toPush = arr[tempIndex]
            }
            tempIndex++

            retArray.push(toPush)
          }
        }
        return retArray
      }
    }
  },
  computed: {
    ...mapGetters([
      'selectedTranslation',
      'centrumData',
      'footerData',
      'errorData',
      'buttonData',
      'dataLoaded',
      'breakpoint',
      'wWidth'
    ]),
    isPhone () {
      return this.breakpoint === 'mobile'
    }
  },
  watch: {
    wWidth (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getArticlesList()
      }
    },
    dataLoaded (newVal, oldVal) {
      if (newVal) {
        this.getPageData()
      }
    }
  },
  mounted () {
    this.togglePageScrolls(false)
    this.resetActiveFilters()
    this.getPageData()
  }
}
</script>

<style scoped lang="scss">
.centrum-page {

  &-header {
    min-height: 50vh;
    padding: $gap-md 0 ($gap-xl * 2);
    width: 100%;
    max-width: ($container-narrow + ($gap-sm * 2));
  } // END .centrum-page-header;

  &-list {
    margin-bottom: $gap-xl;
    position: relative;
    width: 100%;

    ul {
      list-style: none;
      margin: 0;
    }

    ul, li {
      padding: ceil(map-get($centrum-cross, 'size') / 2);
      position: relative;
      width: 100%;
    }

    li {
      min-height: 150px;

      &.hidden {
        display: none;
      }
    }

    a {
      color: $text-dark;
      display: inline-block;
      height: 100%;
      text-decoration: none !important;
      width: 100%;

      h2:before {
        background: $text-accent;
        transition: all ($animation-duration / 2) ease-in-out;
      }

      .btn-simple {
        color: $text-accent;
        opacity: 0;
        padding-top: $gap-sm;
        transition: opacity $animation-duration ease-in-out, transform ($animation-duration / 2) ease-in-out;
        transform: translateY(($gap-sm * -1));
      }

      #app.hight-contrast & {
        color: $contrast-text;

        h2:before {
          background: $contrast-accent;
        }

        .btn-simple {
          color: $contrast-accent;
        }
      }

      &:hover, &:focus {
        outline: 0 none;

        h2:before {
          background: $text-dark;
          width: 100%;

          #app.hight-contrast & {
            background: $contrast-text;
          }
        }

        @include screen ('md') {
          .btn-simple {
            opacity: 1;
            transform: translateY(0);
          }
        }
      }
    } // END .centrum-page-list a;

    &-cross {
      bottom: 0;
      display: inline-block;
      position: absolute;
      left: 0;
    } // END .centrum-page-list-cross;

    &-last-cross {
      bottom: ceil(map-get($centrum-cross, 'size') / 2);
      left: auto;
      right: ceil(map-get($centrum-cross, 'size') / 2);
    } // END .centrum-page-list-last-cross;

    ul {
      &:after {
        @include after(0, map-get($centrum-cross, 'weight'), 0, ceil(map-get($centrum-cross, 'size') / 2), map-get($centrum-cross, 'size'), 10);
      }
      &:before {
        @include after(ceil(map-get($centrum-cross, 'size') / 2), map-get($centrum-cross, 'size'), 0, 0, map-get($centrum-cross, 'weight'), 10);
      }
    }

    li,
    &-cross {
      &:after {
        @include after(auto, map-get($centrum-cross, 'weight'), 0, 0, map-get($centrum-cross, 'size'), 10);
        right: ceil(map-get($centrum-cross, 'size') / -2);
      }
      &:before {
        @include after(auto, map-get($centrum-cross, 'size'), 0, ceil(map-get($centrum-cross, 'size') / -2), map-get($centrum-cross, 'weight'), 10);
        right: 0;
      }
    } // END li, .centrum-page-list-cross;

    ul, li,
    &-list,
    &-cross {
      &:after, &:before {
        background: map-get($centrum-cross, 'color');

        #app.hight-contrast & {
          background: map-get($centrum-cross, 'color-contrast');
        }
      }
    }

    h2 {
      font-size: $font-m-mobile;
      margin: 0;
    }
  } // END .centrum-page-list;

  .animated-shape {
    display: inline-block;
    margin: 0 auto;
    width: 70%;
  }

  .modal  {
    background: rgba($bg-light, 0.95);
    align-items: flex-start;

    #app.hight-contrast & {
      background: $bg-dark;
    }

    &-content {
      padding: ceil($gap-xl * 1.5) $gap-md;
      width: 100%;
    } // END .modal-content;
  } // END .modal;

  @include screen ('sm') {

    .back-btn-bar {
      width: calc(100% - #{($gap-md * 2)});
      max-width: 88vw;
    }

    &-header {
      min-height: 350px;
      padding: $gap-md $gap-sm;
    } // END .centrum-page-header;

    &-list {

      ul {
        align-items: stretch;
        display: flex;
        flex-flow: row wrap;
      }

      li {
        flex: 0 0 50%;
        width: 50%;
      }
    } // END .centrum-page-list;

    .modal  {
      padding: ($gap-xl * 2) 0 $gap-md;

      &-content {
        width: ceil($container-narrow + ($gap-md * 2));
      } // END .modal-content;

      &-close {
        left: 50%;
        margin-left: ceil($container-narrow / 2);
        right: auto;
        top: ceil($gap-xl * 1.5);
      }
    } // END .modal;

  } // END @include screen ('sm');

  @include screen ('md') {
    .back-btn-bar {
      max-width: $container-content-max-width; // calc(90vw - 286px);
    }

    &-list {
      margin-bottom: ($gap-xl * 2);

      ul, li {
        padding: ceil(map-get($centrum-cross, 'size-md') / 2);
      }

      &-last-cross {
        bottom: ceil(map-get($centrum-cross, 'size-md') / 2);
        right: 0;
      } // END .centrum-page-list-last-cross;

      ul {
        margin-left: (map-get($centrum-cross, 'size-md') / -2);
        margin-right: (map-get($centrum-cross, 'size-md') / -2);
        width: auto;

        &:after {
          top: ceil(map-get($centrum-cross, 'size-md') / 2);
          width: map-get($centrum-cross, 'size-md');
        }
        &:before {
          left: ceil(map-get($centrum-cross, 'size-md') / 2);
          height: map-get($centrum-cross, 'size-md');
        }
      }

      li {
        flex: 0 0 percentage(1/3);
        min-height: 215px;
        width: percentage(1/3);
      }

      li,
      &-cross {
        &:after {
          width: map-get($centrum-cross, 'size-md');
          right: ceil(map-get($centrum-cross, 'size-md') / -2);
        }
        &:before {
          height: map-get($centrum-cross, 'size-md');
          top: ceil(map-get($centrum-cross, 'size-md') / -2);
        }
      } // END li, .centrum-page-list-cross;

      h2 {
        font-size: 22px;
      }

    } // END .centrum-page-list;

  } // END @include screen ('md');

  @include screen ('lg') {
    &-list {
      li {
        flex: 0 0 25%;
        width: 25%;
      }
    } // END .centrum-page-list;
  } // END @include screen ('lg');

} // END .centrum-page;
</style>
